import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        modal: String
    }

    connect() {
        this.checkbox = this.element.querySelector('input[type="checkbox"]');
        this.modal = document.getElementById(this.modalValue);

        this.element.querySelector('label')?.addEventListener('click', (e) => {
            const isCheckbox = e.target.type === 'checkbox';
            const isCheckmark = e.target.classList.contains('checkmark');

            if (!isCheckbox && !isCheckmark) {
                e.preventDefault();
            }
        });

        this.modal?.querySelector('.modal-accept')
            ?.addEventListener('click', () => {
                this.checkbox.checked = true;
                this.modal.dispatchEvent(new CustomEvent('modal:close'));
            });
    }
}
